module.exports = __webpack_public_path__ + "static/media/Icon material-pause.7e73eff6.svg";